const Class = {
    "name": "Class Name",
    "status": "Status",
    "description": "Description",
    "search": "Search",
    "class": "Class",
    "error_name": "Enter Class Name",
    "error_status": "Select Status",
    "table_name": "CLASS NAME",
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",
}

export default Class;
